// extracted by mini-css-extract-plugin
export default {"modal__overlay":"modal-overlay_modal__overlay__-82VO","modal__overlay_opened":"modal-overlay_modal__overlay_opened__kh+0H"};